import { render, staticRenderFns } from "./Clients.vue?vue&type=template&id=35d6ea68"
import script from "./Clients.vue?vue&type=script&lang=js"
export * from "./Clients.vue?vue&type=script&lang=js"
import style0 from "./Clients.vue?vue&type=style&index=0&id=35d6ea68&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/Users/dusanvelickovic/Herd/bookybook/bookybook-cms/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('35d6ea68')) {
      api.createRecord('35d6ea68', component.options)
    } else {
      api.reload('35d6ea68', component.options)
    }
    module.hot.accept("./Clients.vue?vue&type=template&id=35d6ea68", function () {
      api.rerender('35d6ea68', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/view/pages/Clients.vue"
export default component.exports